<template>
    <ul class="titan-language">
        <li v-for="lang in languages" :class="{'titan-language-active': value === lang}" @click="setValue(lang)">
            <img :src="'/static/flags/4x3/' + lang + '.svg'" class="flag-icon" :alt="lang">
        </li>
    </ul>
</template>
<script>
    import {abstractField} from "vue-form-generator"

    export default {
        mixins: [abstractField],
        computed: {
            languages() {
                return this.schema.values === undefined ? [] : this.schema.values;
            }
        },
        methods: {
            setValue(lang) {
                this.value = this.value === lang ? null : lang;
            },
        },
    };
</script>
<style lang="scss">
    .titan-language {
        border: 1px solid #ccc;
        border-radius: 4px;
        list-style: none;
        padding: 0;
        display: inline-block;
        margin: 0;

        li {
            display: inline-block;
            height: 36px;
            width: 45px;
            text-align: center;
            cursor: pointer;

            &:first-child {
                border-radius: 3px 0 0 3px;
            }
            &:last-child {
                border-radius: 0 3px 3px 0;
            }
            &.titan-language-active {
                background: #009DFA;
                border-color: #009DFA ! important;
            }

            .flag-icon {
                margin-top: 10px;
                height: 16px;
            }

            &:not(:last-child) {
                border-right: 1px solid #ccc;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/core/Form/Fields/Language.vue